import { Link, LinkProps } from '@chakra-ui/next-js'
import { SystemStyleObject } from '@chakra-ui/styled-system'
import { useRouter } from 'next/router'
import { FC, useMemo } from 'react'

interface ActiveStylesLinkProps extends LinkProps {
  activeLinkStyles?: SystemStyleObject
}

const ActiveStylesLink: FC<ActiveStylesLinkProps> = ({ href, activeLinkStyles, children, ...rest }) => {
  const { pathname } = useRouter()

  // Same answer on the server and in the browser: the Datafolha pages that use it are server-rendered.
  const isActive = useMemo(() => {
    const pathNameContent = pathname.replaceAll('/', '')
    const hrefContent = typeof href === 'string' ? href.replaceAll('/', '') : href.pathname?.replaceAll('/', '')
    return pathNameContent === hrefContent
  }, [href, pathname])

  return (
    <Link prefetch={false} {...{ href }} sx={isActive ? activeLinkStyles : undefined} {...rest}>
      {children}
    </Link>
  )
}

export default ActiveStylesLink
